import React, { useState } from 'react';
import "./css/VacationCompensationPopup.css";
import { useAuth } from '../navigation/AuthProvider';
import axios from 'axios';
import { BACKEND_URL } from '../constants';

function VacationPayPopup({ onClose, setLoading, readOnly }) {
  const { user, company, vacationPay, setVacationPay } = useAuth();

  const [formState, setFormState] = useState({
    vacationPayActive: vacationPay?.vacationPayActive || false,
    vacationPayPercentage: vacationPay?.vacationPayPercentage || 12,
    compensationType: "percent",
  });

  const handleToggleUse = (e) => {
    if (readOnly) return;
    setFormState((prev) => ({ ...prev, vacationPayActive: e.target.checked }));
  };

  const handleValueChange = (e) => {
    if (readOnly) return;
    setFormState((prev) => ({ ...prev, vacationPayPercentage: e.target.value }));
  };

  const handleTypeChange = (e) => {
    if (readOnly) return;
    setFormState((prev) => ({ ...prev, compensationType: e.target.value }));
  };

  const handleSave = async () => {
    if (readOnly) return;

    const { vacationPayActive, vacationPayPercentage } = formState;

    if (
      vacationPayActive &&
      (vacationPayPercentage === "" || isNaN(Number(vacationPayPercentage)))
    ) {
      return alert("Ange ett giltigt nummer för ersättningen.");
    }

    const confirmUpdate = window.confirm(
      "Vill du spara ändringarna av semesterersättningen?"
    );
    if (!confirmUpdate) return;

    try {
      const { data } = await axios.put(`${BACKEND_URL}/edit-vacation-pay`, {
        companyId: company._id,
        userId: user._id,
        vacationPay: {
          vacationPayActive,
          vacationPayPercentage: Number(vacationPayPercentage),
        },
      });

      if (data.status !== "success") {
        return alert(data.errorText || "Något gick fel vid uppdateringen.");
      }

      setFormState({
        vacationPayActive: data.updatedVacationPay.vacationPayActive,
        vacationPayPercentage: data.updatedVacationPay.vacationPayPercentage,
        compensationType: "percent",
      });

      setVacationPay(data.updatedVacationPay);
      alert("Semesterersättning uppdaterad!");
      onClose();
    } catch (error) {
      console.error("Fel vid uppdatering av semesterersättning:", error);
      alert("Ett fel uppstod när uppgifterna skulle sparas.");
    }
  };

  const handleCancel = () => onClose();

  return (
    <div className="vacation-popup">
      <div className="vacation-popup__overlay" onClick={handleCancel} />

      <div className="vacation-popup__content">
        <h2 className="vacation-popup__title">Semesterersättning</h2>

        <p className="vacation-popup__description">
          Semesterersättning är ett tillägg som oftast ges som procent av din lön (t.ex. 12%).
          Här kan du aktivera den och ange vilken typ och nivå som gäller för ditt företag.
        </p>

        <div className="vacation-popup__form">
          <div
            className={`vacation-popup__toggle ${
              formState.vacationPayActive ? 'active' : ''
            }`}
          >
            <label>
              <input
                type="checkbox"
                style={{ marginRight: "10px" }}
                checked={formState.vacationPayActive}
                onChange={handleToggleUse}
                disabled={readOnly}
              />
              <span>Aktivera semesterersättning</span>
            </label>
          </div>

          <div className="vacation-popup__field">
            <label htmlFor="compensationType">Typ av ersättning</label>
            <select
              id="compensationType"
              value={formState.compensationType}
              onChange={handleTypeChange}
              disabled={readOnly || !formState.vacationPayActive}
            >
              <option value="percent">Procent (%)</option>
            </select>
          </div>

          <div className="vacation-popup__field">
            <label htmlFor="vacationPayPercentage">
              {formState.compensationType === "percent"
                ? "Hur många procent?"
                : "Ange belopp i kronor"}
            </label>
            <input
              id="vacationPayPercentage"
              type="number"
              value={formState.vacationPayPercentage}
              onChange={handleValueChange}
              disabled={readOnly || !formState.vacationPayActive}
              placeholder={
                formState.compensationType === "percent" ? "t.ex. 12" : "t.ex. 500"
              }
              className={
                readOnly || !formState.vacationPayActive ? "disabled" : ""
              }
            />
          </div>
        </div>

        <div className="vacation-popup__actions">
          {!readOnly && (
            <button
              className="vacation-popup__btn save"
              onClick={handleSave}
            >
              Spara
            </button>
          )}
          <button
            className="vacation-popup__btn cancel"
            onClick={handleCancel}
          >
            Avbryt
          </button>
        </div>
      </div>
    </div>
  );
}

export default VacationPayPopup;
